import React from 'react'
import { number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import TempleInfo from './TempleInfo/TempleInfo'

const iconStyle = css`
  width: 75px;
  padding-top: 20px;
`
const quantityStyle = css`
  font-family: museo, sans-serif;
`

export default function TempleDedications({ year, comparisonYear, imageUrl, tileContentData, tileComparisonContent }) {
  const [templeImageIndex, setTempleImageIndex] = React.useState(0)

  const selectedYear = comparisonYear ?? year
  const defaultData = tileContentData?.length > 0 ? tileContentData : []
  const templesDedicated = tileComparisonContent ?? defaultData
  const [t] = useTranslation()

  const containerStyle = css`
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: center;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    outline: none;
  `

  return (
    <div
      css={containerStyle}
      onKeyPress={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      role="button"
      tabIndex="-1"
    >
      <img css={iconStyle} src={imageUrl} alt="Temple" />
      <div css={quantityStyle}>
        {templesDedicated.length !== 0
          ? t('aam.temples-dedicated-temple-dedications', { count: templesDedicated.length, year: selectedYear })
          : `No temple dedications in ${selectedYear}`}
      </div>

      <TempleInfo
        info={templesDedicated[templeImageIndex]}
        numTemples={templesDedicated?.length ?? 0}
        moveLeft={() =>
          setTempleImageIndex(templeImageIndex !== 0 ? templeImageIndex - 1 : templesDedicated.length - 1)
        }
        moveRight={() =>
          setTempleImageIndex(templeImageIndex !== templesDedicated.length - 1 ? templeImageIndex + 1 : 0)
        }
      />
    </div>
  )
}

TempleDedications.propTypes = {
  year: number.isRequired,
  tileContentData: shape({
    category: string,
    categoryId: number,
    endYear: number,
    icon: string,
    id: number,
    image: string,
    imagUrl: string,
    languageOnly: string,
    localeOnly: string,
    startYear: number,
    subcategory: string,
    textAdditional: string,
    textHeadline: string,
    textTitle: string,
    tileType: string,
    year: number,
  }),
}
